function promiseFailSilently(promiseCreator) {
  return function () {
    return promiseCreator(...arguments).catch((e) => e);
  };
}

export default promiseFailSilently;
